"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cross_fetch_1 = __importDefault(require("cross-fetch"));
class Api {
    static getCredentials(endpoint, environmentId, agentToken) {
        return this.credentialsRequest(endpoint, environmentId, this.AUTHORIZATION_CODE, this.CODE, agentToken);
    }
    static refreshCredentials(endpoint, environmentId, refreshToken) {
        return this.credentialsRequest(endpoint, environmentId, this.REFRESH_TOKEN, this.REFRESH_TOKEN, refreshToken);
    }
    static credentialsRequest(endpoint, environmentId, grantType, tokenType, token) {
        return cross_fetch_1.default(endpoint + '/environment/' + environmentId + '/credentials', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: 'grant_type=' + grantType + '&' + tokenType + '=' + token
        });
    }
}
Api.AUTHORIZATION_CODE = 'authorization_code';
Api.REFRESH_TOKEN = 'refresh_token';
Api.CODE = 'code';
exports.default = Api;
//# sourceMappingURL=Api.js.map